<template>
  <form
    id="create-rule-form"
    name="create-rule-form"
    @submit="onSubmit"
  >
    <b-alert :show="!!formErrors" variant="danger">
      <ul>
        <li> {{formErrors}}</li>
      </ul>
    </b-alert>
    <div class="row">
      <div class="col-md-12">
        <b-form-group :label="$t('report.name')" label-for="name">
          <div class="input-group">
            <b-form-input
              v-model="formData.name"
              v-validate="'required'"
              type="text"
              id="name"
              name="name"
              :class="{'is-invalid': errors.has('name') }"
              :placeholder="$t('report.name')">
            </b-form-input>
          </div>
          <div class="invalid-feedback text-right"> {{ errors.first('name') }} </div>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group" >
          <label>{{$t('report.condition')}}:</label>
          <div class="input-group">
            <input type="hidden" :class="{'is-invalid': errors.has('condition')}" name="condition" v-model="formData.conditions" v-validate="'required'" />
            <div class="invalid-feedback text-right"> {{ errors.first('condition') }} </div>
          </div>
          <div class="row mb-2"  v-for="(condition, index)  in formData.conditions" track-by="$index">
            <div class="col-sm-5">
              <b-form-select v-model="condition.key"
                             :options="ruleOptions"
                             @change="onConditionChange(index)"
                             name="conditions['key'][]">
              </b-form-select>
            </div>
            <div class="col-sm-6" :set="conditionValueName=`condition-value-${index}`">
              <div class="input-group">
                <rule-form-field
                  class="w-100"
                  :class="{'is-invalid': errors.has(conditionValueName) }"
                  :type="condition.key"
                  v-model="condition.value"
                  :name="conditionValueName"
                  :options="ruleOptionsByKey[condition.key]"
                  v-validate="'required'"
                >
                </rule-form-field>
              </div>
              <div class="invalid-feedback text-right"> {{ errors.first(conditionValueName) }} </div>
            </div>
            <div class="col-sm-1 pt-1">
              <a @click="removeCondition(index)" class="remove-condition" href="javascript:">
                <i class="fal fa-trash"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <a href="javascript:" @click="addCondition()">
          <i class="fal fa-plus"></i>
          {{$t('report.addCondition')}}
        </a>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col-12">
        <h5>
          {{$t('report.results')}}
        </h5>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="form-group" >
          <label>{{$t('report.setTags')}}:
            <a href="javascript:" @click="addTag()">
              <i class="fal fa-plus"></i>
              {{$t('report.createTag')}}
            </a>
          </label>
          <p class="field-desc">
            {{$t('report.setTagsDesc')}}
          </p>
          <div class="input-group">
            <b-form-checkbox-group
              v-model="formData.tags"
              :options="tagOptions"
              name="tags"
              class="form-control multi-checkbox"
              :class="{'is-invalid': errors.has('tags') }"
            ></b-form-checkbox-group>
          </div>
          <div class="invalid-feedback text-right"> {{ errors.first('tags') }} </div>
        </div>
      </div>
    </div>
    <input id="submit-btn" style="display: none"
      type="submit"
      value="Submit"
    >
  </form>
</template>

<script>
import { mapState } from 'vuex';
import { createListOptions } from '@/utils/select-options';
import { INVOICE_RULES } from '@/app-constant';
import AppForm from '@/components/app-form/';
import AppAutoComplete from '@/components/app-autocomplete/';
import { getDirectoryOptions } from '@/utils/directory';
import { getTagOptions } from '@/utils/tag';
import RuleFormField from './rule-form-field';

export default {
  name: 'RuleForm',
  components: {
    AppForm,
    AppAutoComplete,
    RuleFormField,
  },
  props: {
    formData: Object,
    invoice: Object,
  },
  data() {
    return {
      formErrors: '',
      ruleOptions: createListOptions('INVOICE_RULES', false),
      tagOptions: getTagOptions(),
      ruleOptionsByKey: {
        RULE_UNIT: createListOptions(INVOICE_RULES.RULE_UNIT, false),
        RULE_KIND_OF: createListOptions(INVOICE_RULES.RULE_KIND_OF, false),
        RULE_PAID_DATE: createListOptions(INVOICE_RULES.RULE_PAID_DATE, false),
      },
      directoryOptions: getDirectoryOptions(),
    };
  },
  created() {
    this.$bus.on('close-tag-modal', this.onCloseTagModal);
  },
  beforeDestroy() {
    this.$bus.off('close-tag-modal', this.onCloseTagModal);
  },
  computed: {
    ...mapState(['tags']),
  },
  mounted() {

  },
  methods: {
    onCloseTagModal() {
      const set = new Set([
        ...this.tagOptions.map(t => t.value),
      ]);
      const idx = this.tags.findIndex(tag => !set.has(tag.id));
      this.tagOptions = [
        ...this.tagOptions,
        {
          text: this.tags[idx].name,
          value: this.tags[idx].id,
        }];
    },
    addTag() {
      this.$modal.show('tag-modal', { model: {} });
    },
    onConditionChange(index) {
      this.formData.conditions[index].value = null;
    },
    removeCondition(index) {
      this.formData.conditions.splice(index, 1);
    },
    submit() {
      this.$el.querySelector('#submit-btn').click();
    },
    addCondition() {
      this.formData.conditions.push({
        key: INVOICE_RULES.RULE_CUSTOMER,
        value: null,
      });
    },
    onSubmit($event) {
      $event.preventDefault();
      this.formErrors = '';
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.formData.tags.length === 0 && !this.formData.target) {
            this.formErrors = this.$t('rule.dirOrTagCannotEmpty');
          } else {
            this.$emit('submit', {
              formData: this.formData,
              $event,
              isValid,
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
input[name="condition"].is-invalid + .invalid-feedback{
  border: 1px solid red;
  padding: 8px;
  border-radius: 4px;
  margin: 6px 0px;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/rule/rule-form.vue